<template>
  <div class="container-fluid mt-4">
    <b-row class="mx-auto text-center" align-v="center">
      <b-col cols="6" lg="4" xl="3" class="noselect px-1 align-items-center">
        <router-link to="/Tables" class="btn btn-huge btn-success align-items-center">
          <i class="material-icons">important_devices</i>
          <br />POS
        </router-link>
      </b-col>

      <b-col
        cols="6"
        lg="4"
        xl="3"
        class="noselect px-1 align-items-center"
        v-if="[1,3].indexOf(User.RoleID) !== -1"
      >
        <router-link to="/Kitchen" class="btn btn-huge btn-info align-items-center">
          <i class="material-icons">restaurant</i>
          <br />Mutfak
        </router-link>
      </b-col>

      <b-col
        cols="6"
        lg="4"
        xl="3"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link to="/Products" class="btn btn-huge btn-info align-items-center">
          <i class="material-icons">fastfood</i>
          <br />Ürünler
        </router-link>
      </b-col>

      <b-col
        cols="6"
        lg="4"
        xl="3"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link to="/Balance" class="btn btn-huge btn-info align-items-center">
          <i class="material-icons">dvr</i>
          <br />Muhasebe
        </router-link>
      </b-col>

      <b-col
        cols="6"
        lg="4"
        xl="3"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link to="/Staff" class="btn btn-huge btn-info align-items-center">
          <i class="material-icons">supervisor_account</i>
          <br />Personeller
        </router-link>
      </b-col>

      <b-col cols="6" lg="4" xl="3" class="noselect px-1 align-items-center">
        <router-link to="/Settings" class="btn btn-huge btn-info align-items-center">
          <i class="material-icons">settings</i>
          <br />Ayarlar
        </router-link>
      </b-col>

      <b-col cols="6" lg="4" xl="3" class="noselect px-1 align-items-center">
        <a
          href="#"
          @click.prevent="() => { Logout(); return false; }"
          class="btn btn-huge btn-danger align-items-center"
        >
          <i class="material-icons">lock</i>
          <br />Kilitle
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import datetr from "@/Date";

export default {
  computed: {
    ...mapState(["User"])
  },
  methods: {
    Logout() {
      this.$store.dispatch("Logout");
    },
    date: (timestamp, format = "dd.mm.yyyy") => {
      return datetr(timestamp, format);
    },
    daysBetween(date1, date2) {
      var one_day = 1000 * 60 * 60 * 24;

      var date1_ms = date1.getTime();
      var date2_ms = date2.getTime();

      var difference_ms = date2_ms - date1_ms;

      return Math.round(difference_ms / one_day);
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
